import { Pipe, PipeTransform } from '@angular/core';

import { Currency } from '@app/core/models/customer.models';
import { formatCurrency } from '@app/core/services/metrics-calculations.service';

@Pipe({ name: 'formatCurrency' })
export class FormatCurrencyPipe implements PipeTransform {
  transform(value: string | number, currency?: Currency, ignoreFormat = false): string {
    return formatCurrency(value, currency, ignoreFormat);
  }
}
